import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import {useDispatch, useSelector} from "react-redux";
import {addSelectedSpace, removeSelectedSpace} from "../../../redux/actions/transactionActions";

const Spinner = ({index, mini, singleOccupancy}) => {
    const classes = `numBerths ${mini ? 'mini' : ''}`;
    const dispatch = useDispatch();
    const {selectedRooms} = useSelector(state => state.transactions);
    const {data: trip} = useSelector(state => state.trip);
    const rooms = useSelector(state => state.rooms);

    const quantity = selectedRooms.filter(room => room.index === index).length;
    const currentRoom = rooms.find(r => r.index === index);
    const limit = currentRoom.spaces;

    const maxPax = selectedRooms.length >= parseInt(trip.available);

    const handleIncrement = () => {
        const single = singleOccupancy || false;
        dispatch(addSelectedSpace(index, single));
    };

    const handleDecrement = () => {
        dispatch(removeSelectedSpace(index));
    };

    return (
        <ButtonGroup variant={"text"} size="small" aria-label="small outlined button group" className={classes}>
            {quantity > 0 && <Button color="secondary" onClick={handleDecrement}>-</Button>}
            {quantity > 0 && <Button color="secondary" disabled>{quantity}</Button>}
            <Button color="secondary" onClick={handleIncrement} disabled={(quantity >= limit) || maxPax}>+</Button>
        </ButtonGroup>
    );
};

export default Spinner;